"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const cosmosBase_1 = __importDefault(require("./cosmosBase"));
class SecretNetwork extends cosmosBase_1.default {
    constructor() {
        super();
        this.stakingDocUrl = "https://support.ledger.com/hc/en-us/articles/9604764378781?support=true";
        this.unbondingPeriod = 28;
        this.prefix = "secret";
        this.validatorPrefix = `${this.prefix}valoper`;
    }
}
exports.default = SecretNetwork;
//# sourceMappingURL=SecretNetwork.js.map